import React, { useEffect, useState } from "react";
import "/node_modules/bootstrap/dist/css/bootstrap.min.css";
import Footer from "./footer";
import "./index.css";
import HomePage from "./Homepage";
import Avbar from "./navbar/Navbar";
import Timeline from "./Timeline";
import Portfolio from "./Technologies";
import ProjectCards from "./Pages/ProjectCards";
import "primeicons/primeicons.css";
import { PrimeReactProvider } from "primereact/api";
// import 'primeflex/primeflex.css';
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

import { keyframes } from "@emotion/react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Preloader from "./Preloader";
export const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000); // Set the loading duration to 3 seconds
  }, []);
  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <div className="App">
          <Avbar />
          <HomePage />
          <PrimeReactProvider>
            <ProjectCards />
          </PrimeReactProvider>
          <Timeline />
          <Portfolio />
          <div className="text-center p-2">
            <Button>
              <Link to="/Resume" className="nav-link">
                My Resume
              </Link>
            </Button>
            <Button>
              <Link to="/Contact" className="nav-link">
                Contact Me
              </Link>
            </Button>
          </div>{" "}
          <Footer />
        </div>
      )}
    </>
  );
}

export default App;
